<template>
    <div>
        <routes-list :item="item" :key="item" v-for="item in items"></routes-list>
    </div>
</template>

<script>
//    import RouteListItems from './RouteListItems'
import RoutesList from './RoutesList';
export default {
    components: {
        RoutesList
    },
    created() {
        this.$router.options.routes.forEach(route => {
            this.items.push({
                children: route.children,
                name: route.name,
                path: route.path
            });
        });
    },
    data() {
        return {
            items: []
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/views/Debug/Routes/Routes.vue